import { render, staticRenderFns } from "./SkeletonNoticias.vue?vue&type=template&id=11ad7a74&scoped=true"
import script from "./SkeletonNoticias.vue?vue&type=script&lang=js"
export * from "./SkeletonNoticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad7a74",
  null
  
)

export default component.exports